export default __webpack_public_path__ + "maps-guides-view-annotation-z-index-1200-1b80334de53fc0a818f68f0122c3540f.png";